import { AuthService } from '../../shared/services/auth.service';
var HeaderComponent = (function () {
    function HeaderComponent(auth) {
        var _this = this;
        this.auth = auth;
        this.isLoggedIn = false;
        auth.loggedIn.subscribe(function (value) { return _this.isLoggedIn = value; });
    }
    HeaderComponent.prototype.ngOnInit = function () {
    };
    return HeaderComponent;
}());
export { HeaderComponent };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/header/header.component.ts.pre-build-optimizer.js